module.exports = __webpack_public_path__ + "static/media/catering-3.cc6f7a01.jpg";